import React from "react";
import { useTranslation } from "react-i18next";

interface UnavailableCIReferralProps {}

export const UnavailableCIReferral: React.FC<UnavailableCIReferralProps> = () => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });

    return (
        <div className="unavailable-ci-referral-root">
            <div className="illustration">
                <img src="/images/white_purple_flower.jpg" alt="Flower illustration" width="344" height="218" />
            </div>
            <section className="bottom-half">
                <h1>{t('referral_unavailable')}</h1>
                <p>{t('referral_no_longer_available')}</p>
            </section>
        </div>
    );
};
